module.exports = __webpack_public_path__ + "img/study-outline.2621f12d.png";